import { Center, Spinner, Text, VStack } from "@chakra-ui/react"
import React, { useCallback, useState } from "react"
import { AllTagsQueryVariables, useAllTagsQuery } from "../../graphql"
import { TagsList } from "./TagsList"

export const AllTags: React.FC = () => {
	const [pagination, setPagination] = useState<AllTagsQueryVariables["pagination"]>({ limit: 20, page: 1 })

	const [{ data, fetching, error }] = useAllTagsQuery({
		variables: { pagination },
	})

	const nextPage = useCallback(() => {
		if (data?.allTags.hasNextPage) {
			setPagination((prev) => ({
				...prev,
				page: (prev.page || 0) + 1,
			}))
		}
	}, [data])

	return (
		<VStack w="full" maxW="2xl" align="stretch">
			{fetching && !data?.allTags ? (
				<Center w="full" py="4">
					<VStack w="full" color="grayscale.label">
						<Text fontSize="sm">Loading tags</Text>
						<Spinner size="sm" />
					</VStack>
				</Center>
			) : error ? (
				<Center py="4">
					<Text fontSize="sm" fontWeight="semibold" color="error.500">
						{error.message.replace("[GraphQL] ", "")}
					</Text>
				</Center>
			) : data?.allTags.tags && data.allTags.tags.length ? (
				<VStack w="full" align="stretch">
					<Text>
						Showing {data.allTags.tags.length || 0} tag
						{(data.allTags.tags.length || 0) > 1 ? "s" : ""}
					</Text>

					<TagsList tags={data.allTags.tags} loadMore={nextPage} />

					{fetching && (
						<Center w="full" py="4">
							<VStack w="full" color="grayscale.label">
								<Text fontSize="sm">Loading more tags</Text>
								<Spinner size="sm" />
							</VStack>
						</Center>
					)}
				</VStack>
			) : (
				<Center py="4">
					<Text fontSize="sm" fontWeight="semibold" color="error.500">
						Couldn&apos;t find any tags.
					</Text>
				</Center>
			)}
		</VStack>
	)
}
